const getValue = (field, fieldKey, data) => {
  const item = data.find(refEl => {
    return refEl.code === field.code;
  });
  return item ? item[fieldKey] : "";
};

const constructData = (item, data) => {
  const returnValue = {};
  Object.keys(item).forEach(i => {
    if (i !== "code") {
      returnValue[i] = getValue(item, i, data);
    }
  });
  return { target: { value: { code: item.code.toUpperCase(), ...returnValue } } };
};

const isDataValid = (allProps, data, componentName) => {
  const codeNotInData = allProps[data].some(v => !v.code);
  if (codeNotInData) {
    return new Error(`Invalid prop ${data} passed to ${componentName}. All items should have "code" property.`);
  }
  return null;
};

const isValueValid = (allProps, value, componentName) => {
  if (allProps[value] && allProps[value].code == null) {
    return new Error(`Invalid prop ${value} passed to ${componentName}. It should have "code" property.`);
  }
  return null;
};

const prepareData = (event, data, searchBy) => {
  const targetValue = event.target.value;
  const item = data.find(refEl => {
    return refEl[searchBy] === targetValue;
  });
  if (item) {
    return constructData(item, data);
  }
  return { target: { value: { code: event.target.value } } };
};

const prepareRowClickUpdate = (newValue, value, data) => {
  return constructData(newValue, data);
};

const filterContent = (content, customFilter, data, searchBy) => {
  let filtereddata = [];
  if (customFilter) {
    filtereddata = customFilter(data);
  } else {
    filtereddata = [...data];
  }
  return filtereddata.filter(refEl => {
    return refEl[searchBy].startsWith(content);
  });
};

const checkData = (event, searchBy, data) => {
  const newValue = event.target.value;
  return data.find(refEl => {
    return refEl[searchBy] === newValue;
  });
};

export { isDataValid, isValueValid, prepareData, prepareRowClickUpdate, filterContent, checkData };
